export enum RoleTypeEnum {
  SECURITY_ADMIN = 'SECURITY_ADMIN',
  ADMIN = 'ADMIN',
  MONITOR = 'MONITOR',
  ROUTING = 'ROUTING',
  USER_GROUP = 'USER_GROUP',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  NORMALIZATION_GROUP = 'NORMALIZATION_GROUP',
  PREFIX_GROUP = 'PREFIX_GROUP',
  POLICY_STUDIO = 'POLICY_STUDIO'
}
